import { Component, ViewChild, Input } from '@angular/core';

import { OverlayPanel } from 'primeng/overlaypanel';
import { Subject, Observable } from 'rxjs';

import { MySelectComponent } from '../input-components/my-select/my-select.component';
import { DataType } from '../../enums/datatype.enum';

import * as $ from 'jquery';

export interface IOptionLabel {
  propriedade: string;
  dataType?: DataType;
}

@Component({
  selector: 'app-popover-dropdownlist',
  templateUrl: './popover-dropdownlist.component.html'
})
export class PopoverDropdownlistComponent {

  @ViewChild('op') public op: OverlayPanel;
  @ViewChild('mySelect') public mySelect: MySelectComponent<any>;

  @Input() carregarDropdown: Function;

  selectedOption: any;
  event: any;
  idCelula: string;
  valorCelula: string | number;
  subject: Subject<string>;
  placeholder: string;
  options: any[];
  optionLabel: IOptionLabel[];

  constructor() { }

  show(event: any
      , options: any[]
      , optionsLabel: IOptionLabel[]
      , idCelula?: string
      , valorCelula?: string | number
      , placeholder?: string ): Observable<any> {

        this.event = event;
        this.idCelula = idCelula;
        this.valorCelula = valorCelula;
        this.op.show(event);
        this.placeholder = placeholder;
        this.options = options;
        this.optionLabel = optionsLabel;

        // limpar celula antiga, caso exista ( caso o popover nao saia da tela, o metodo onBeforeHide nao chega a ser chamado )
        if (this.idCelula) {
            $(document.querySelector('#' + this.idCelula)).removeClass('em_edicao');
            $(document.querySelector('#icon_edit' + this.idCelula)).removeClass('em_edicao');
        }

      return this.subject = new Subject();
  }

  onShow() {
    this.selectedOption = null;

    this.mySelect.getObservable()
                 .subscribe( response => {
                    this.subject.next(response);
                    this.op.hide();
                 });

    setTimeout(() => {
      if (this.valorCelula) {
          this.selectedOption = this.valorCelula;
      }

      $(document.querySelector('#' + this.idCelula)).addClass('em_edicao');
      $(document.querySelector('#icon_edit' + this.idCelula)).addClass('em_edicao');
    }, 200);
  }

  onHide() {
    this.subject.complete();
    this.mySelect.finish();

    $(document.querySelector('#' + this.idCelula)).removeClass('em_edicao');
    $(document.querySelector('#icon_edit' + this.idCelula)).removeClass('em_edicao');
    this.selectedOption = null;
    this.event = null;
    this.idCelula = null;
    this.valorCelula = null;
    this.options = null;
    this.optionLabel = null;
  }

  onEsc(event: any) {
      this.op.hide();
  }
}
